import { FDIC, NDIC } from "asset/icons";
import React from "react";

const AuthFooter = () => {
    return (
        <div className="w-full md:px-6 pb-10 text-center z-40">
            <p className="text-[#101828] text-base font-base leading-6 max-w-2xl mx-auto">
                Your financial platform for global trade - seamless cross-border payments,
                multi-currency accounts, and embedded trade finance for importers and exporters.
            </p>

            <p className="text-[#6F739B] mt-6 font-base text-l">All deposits are insured by</p>

            <div className="flex justify-center items-center gap-8 mt-2">
                <div className="mt-[5px]">
                    <NDIC />
                </div>

                <FDIC />
            </div>

            <p className="!mt-5 text-sm text-[#4F5372] font-base">
                Copyright © {new Date().getFullYear()} Tradevu Technology Limited. All Rights
                Reserved.
            </p>
        </div>
    );
};

export default AuthFooter;
